import React from 'react';
import { Helmet } from 'react-helmet-async';
import LandingPage from './LandingPage/LandingPage';
import Services from './Services/Services';
import Highlight from './HighlightSection/Highlight';
import Arcade from './Arcade/Arcade';
import ScreenShotScreen from './ScreenShotScreen/ScreenShotScreen';
import TabScreen from './TabScreen/TabScreen';
import LearnAndGrowSection from './ColorScreens/LearnAndGrowSection';
import SecuritySection from './ColorScreens/SecuritySection';
import PricingModelAd from './ColorScreens/PricingModelAd';
import SubscribeSection from './NewsLetter/SubscribeSection';
import { SCREEN_SHOT_CONTENT } from './ScreenShotScreen/export';
import { REGION_CONTENT } from '../data/regionContent';

const HREFLANG_LINKS = [
  { hreflang: 'en-IN', href: 'https://shipmnts.com/in' },
  { hreflang: 'en-AE', href: 'https://shipmnts.com/uae' },
  { hreflang: 'en-US', href: 'https://shipmnts.com/us' },
  { hreflang: 'x-default', href: 'https://shipmnts.com' },
];

const HomeRegional = ({ region }) => {
  const content = REGION_CONTENT[region] || REGION_CONTENT.global;

  return (
    <>
      <Helmet>
        <title>{content.metaTitle}</title>
        <meta name="description" content={content.metaDescription} />
        {HREFLANG_LINKS.map(({ hreflang, href }) => (
          <link key={hreflang} rel="alternate" hreflang={hreflang} href={href} />
        ))}
      </Helmet>
      <LandingPage
        title={content.title}
        subtitle={content.subtitle}
        complianceTags={content.complianceTags}
      />
      <Services />
      <Highlight />
      <Arcade />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['customer_centric_features']} />
      <TabScreen />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['actionable_insight']} />
      <ScreenShotScreen {...SCREEN_SHOT_CONTENT['productivity_and_multi_party_collaboration']} />
      <LearnAndGrowSection />
      <SecuritySection />
      <PricingModelAd />
      <SubscribeSection />
    </>
  );
};

export default HomeRegional;
